<template>
  <div>
    <Page :title="pageTitle">
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <OnboardingChecklist />
          <Overview />
          <GoogleAccountConnector />
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";

import GoogleAccountConnector from "../components/Widget/GoogleAccountConnector.vue";
import Overview from "../components/Widget/Overview.vue";
import OnboardingChecklist from "../components/Onboarding/OnboardingChecklist.vue";

export default {
  components: {
    Page,
    GoogleAccountConnector,
    Overview,
    OnboardingChecklist
  },
  data() {
    return {
      pageTitle: "Overview"
    };
  },
  created() {
    this.$store.dispatch("getConfig");
  },
  computed: {
    isGoogleConfigured() {
      const googleAccount = this.$store.getters.getGoogleAccount;
      if (googleAccount.isGoogleConnected === false) {
        return false;
      }
      if (typeof googleAccount.locationId === "undefined") {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
